// 代码模板
/* <custom-swiper data-config="">
<div class="swiper-container swiper">
  <div class="swiper-wrapper">
    {% for block in section.blocks %}
      <div class="swiper-slide">
      </div>
    {% endfor %}
  </div>
  {% if section.blocks.size > 1 %}
    <div class="swiper-scrollbar" data-scrollbar></div>
    <div class="swiper-pagination" data-pagination></div>
  {% endif %}
</div>
{% if section.blocks.size > 1 %}
  <div class="swiper-button-next" data-swiper-next-button></div>
  <div class="swiper-button-prev" data-swiper-prev-button></div>
{% endif %}
</custom-swiper> */
document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get("custom-swiper")) {
        customElements.define("custom-swiper", class CustomSwiper extends HTMLElement {
            constructor() {
                super();
                this.swiperContainer = this.querySelector(".swiper-container");
                if (this.dataset.config) {
                    this.config = JSON.parse(this.dataset.config);
                }
                this.style.display = 'block'
                this.swiper = null;
                this.prev = this.querySelector("[data-swiper-prev-button]");
                this.next = this.querySelector("[data-swiper-next-button]");
                this.scrollbar = this.querySelector("[data-scrollbar]");
                this.isPauseOnMounseenter = this.hasAttribute("data-pause-onmouseenter");
                this.pagination = this.querySelector("[data-pagination]");
                console.log("this.config", this.config);

                const config = {
                    ...this.config,
                    "observer": true,
                    "observeParents": true,
                    "observeSlideChildren": true
                }
                if (this.prev && this.next) {
                    config.navigation = {
                        prevEl: this.prev,
                        nextEl: this.next
                    }
                }
                if (this.scrollbar) {
                    config.scrollbar = {
                        el: this.scrollbar
                    }
                }
                if (this.pagination) {
                    config.pagination = {
                        el: this.pagination
                    }
                }
                console.log("config", config);
                this.swiper = new Swiper(this.swiperContainer, config);
                if (this.isPauseOnMounseenter) {
                    // 鼠标放在上面暂停，未完成
                    this.addEventListener("mouseenter", this.onMouseEnter.bind(this))
                    this.addEventListener("mouseleave", this.onMouseOut.bind(this))

                }
                this.addEventListener("swipeTo", e => { this.swipeTo.bind(this, e.detail.index)(); });


                // 监听切换事件
                this.swiper.on('slideChangeTransitionEnd', () => {
                    let index = this.swiper.activeIndex
                    document.querySelector('.switch_container custom-swiper').dispatchEvent(
                        new CustomEvent('swiper_touch', {
                            detail: {
                                index
                            },
                        })
                    );
                })
            }
            swipeTo(index) {
                if (this.swiper) {
                    this.swiper.slideTo(index);
                }
            }
            onMouseEnter() {
                console.log('mouse enter');
                // this.swiper.autoplay.stop();
            }
            onMouseOut() {
                console.log('mouse out');
                // this.swiper.autoplay.start();
            }
            connectedCallback() {

            }
        })
    }
})